var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`atlas-text-sm atlas-h-full atlas-w-full 
  ${_vm.isSiteReport ? 'atlas-block' : 'atlas-flex'}`,attrs:{"id":"app"}},[_c('div',{attrs:{"id":"drawings-bar"}}),_c('router-view'),_c('HotJarSnippet')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }